import type { FileResponseItem } from '../models.ts';

export function getPreviewableType(fileName: string): 'pdf' | 'text' | 'video' | 'audio' | 'zip' | null {
  const ext = fileName.split('.').pop()?.toLowerCase();
  if (ext === 'pdf') return 'pdf';
  if (['mp4', 'webm', 'ogv', 'mov'].includes(ext ?? '')) return 'video';
  if (['mp3', 'wav', 'ogg', 'opus', 'm4a', 'aac', 'flac'].includes(ext ?? '')) return 'audio';
  if (['zip', '7z', 'rar'].includes(ext ?? '')) return 'zip';
  if (['txt', 'md', 'markdown', 'json', 'xml', 'csv', 'html', 'htm', 'svg',
       'sql', 'log', 'yaml', 'yml', 'toml', 'ts', 'tsx', 'js', 'jsx',
       'py', 'css', 'scss', 'sh', 'bat', 'ini', 'conf', 'rs', 'go',
       'cs', 'cpp', 'c', 'h', 'java', 'kt', 'rb', 'php'].includes(ext ?? '')) return 'text';
  return null;
}

export function getShareUrl(file: Pick<FileResponseItem, 'id' | 'customName'>): string {
  return file.customName
    ? `${window.location.origin}/f/${file.customName}`
    : `${window.location.origin}/file/download/${file.id}`;
}

export function getExpirationWarning(file: FileResponseItem): string | null {
  if (!file.expirationDateTime) return null;
  const exp = new Date(file.expirationDateTime);
  const now = new Date();
  const daysLeft = Math.ceil((exp.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));
  if (daysLeft <= 0) return 'Expiring today';
  if (daysLeft <= 30) return `Expires in ${daysLeft} day${daysLeft === 1 ? '' : 's'}`;
  return null;
}
